module.exports = __webpack_public_path__ + "static/media/refillIcon.35ddc659.png";